import { HHStack } from '@hinge-health/react-component-library';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { BillingType, ClientType, PartnershipType } from '../../../../types';
import {
  InsurersType,
  SubmissionManagementGridFilterModelType,
} from '../../bill-grid-components/bill-management-types';
import { SubmissionAdvancedFilters } from '../advanced-filters/submission-advanced-filters';
import { SubmissionQuickFilters } from './submission-quick-filters';

export interface SubmissionFiltersToolbarProps {
  filterParams: SubmissionManagementGridFilterModelType;
  setFilterParams: React.Dispatch<
    React.SetStateAction<SubmissionManagementGridFilterModelType>
  >;
  clients: ClientType[];
  insurers: InsurersType[];
  partnerships: PartnershipType[];
  billingTypes: BillingType[];
  setPaginationModel: React.Dispatch<React.SetStateAction<GridPaginationModel>>;
  isLoading: boolean;
  hasError: boolean;
}

const SubmissionFiltersToolbar = ({
  clients,
  insurers,
  partnerships,
  billingTypes,
  filterParams,
  setFilterParams,
  setPaginationModel,
  isLoading,
  hasError,
}: SubmissionFiltersToolbarProps): JSX.Element => {
  const [advancedFiltersOpen, setAdvancedFiltersOpen] = useState(false);

  return (
    <HHStack paddingLeft={6}>
      {advancedFiltersOpen && !isLoading ? (
        <SubmissionAdvancedFilters
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          clients={clients}
          insurers={insurers}
          partnerships={partnerships}
          billingTypes={billingTypes}
          hasError={hasError}
          filterToggle={(): void =>
            setAdvancedFiltersOpen(!advancedFiltersOpen)
          }
          setPaginationModel={setPaginationModel}
        />
      ) : (
        <SubmissionQuickFilters
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          filterToggle={(): void =>
            setAdvancedFiltersOpen(!advancedFiltersOpen)
          }
          setPaginationModel={setPaginationModel}
        />
      )}
    </HHStack>
  );
};

export default SubmissionFiltersToolbar;
